import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostTitleInterface } from 'common/types/entities/BlogPostTitleInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostTitle(
  parentId: string,
  masterBlockId?: MasterBlockId,
): BlogPostTitleInterface {
  const blogPostTitle: BlogPostTitleInterface = {
    id: generateId(),
    type: EntityTypeEnum.BlogPostTitle,
    parentId: parentId,
    fontSize: 27,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 20,
    alignSelf: 'center',
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.BlogPostTitle),
  }

  if (masterBlockId) {
    blogPostTitle.masterBlockId = masterBlockId
  }

  return blogPostTitle
}
